import { observer } from 'mobx-react';
import BranchesLogListRowSkeleton from '../../components/BranchesLogListRowSkeleton/BranchesLogListRowSkeleton';
import { BRANCHES_LOG_COLUMN } from '~/view/screens/BranchLogScreen/screens/BranchesLogScreen/constants/branchesLogRow';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { SORTING_DIRECTION } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import { emptyArray } from 'src/utils/helpers';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import { PaginationType } from 'src/view/components/Controls/PaginationOld/types';
import branchesLogStore from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/store/branchesLogStore';
import BranchesLogListRow from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/components/BranchesLogListRow/BranchesLogListRow';
import './style.scss';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';

const BranchesLogList = (): JSX.Element => {
  // --------------- Handlers ---------------
  const onChangeSorting = (sortBy: BRANCHES_LOG_COLUMN | undefined, sortDir: SORTING_DIRECTION | undefined) => {
    branchesLogStore.setFilters({ sortBy, sortDir });
  };

  const { pagination, filters } = branchesLogStore;

  const isListLoading = (pagination.loading || pagination.refreshing) && !pagination.total;
  // const isListLoading = true;
  const emptyListTitle = 'no_branches_log_found';

  interface ITitleProps {
    name: BRANCHES_LOG_COLUMN | undefined;
    title: string;
    cellName: BRANCHES_LOG_COLUMN;
  }

  const BranchLogColumnTitle: React.FC<ITitleProps> = ({ name, title, cellName }) => {
    return (
      <ColumnTitle<BRANCHES_LOG_COLUMN>
        columnName={name}
        title={title}
        currentField={filters.sortBy}
        currentDir={filters.sortDir}
        setFilters={onChangeSorting}
        className={`cell-${cellName}`}
      />
    );
  };

  const BranchLogColumnTitles: React.FC<any> = (): JSX.Element => {
    return (
      <div className="d-flex flex-row pb-4 branches-log-headers">
        <BranchLogColumnTitle name={BRANCHES_LOG_COLUMN.BRANCH} title="branch" cellName={BRANCHES_LOG_COLUMN.BRANCH} />
        <BranchLogColumnTitle name={BRANCHES_LOG_COLUMN.DATE} title="date" cellName={BRANCHES_LOG_COLUMN.DATE} />
        <BranchLogColumnTitle name={undefined} title="object" cellName={BRANCHES_LOG_COLUMN.OBJECT} />
        <BranchLogColumnTitle name={BRANCHES_LOG_COLUMN.AUTHOR} title="author" cellName={BRANCHES_LOG_COLUMN.AUTHOR} />
        <BranchLogColumnTitle name={undefined} title="details" cellName={BRANCHES_LOG_COLUMN.DETAILS} />
      </div>
    );
  };

  return (
    <div className="d-flex flex-column flex-1 mt-4">
      {!pagination.data.length && !pagination.loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center mt-6">
          <img src={formatImagePath(`${Icons.BranchesTree}.svg`)} alt={emptyListTitle} className="image__no-found mb-6" />
          <p className="family-medium text-size-24 color-gray2">{localeStore.t(emptyListTitle)}</p>
        </div>
      ) : (
        <ScrollableBlock
          showScrollbar
          scrollClassName="d-flex flex-column full-height pr-3"
          className="overflow-y-scroll mb-3 branches-log"
          direction="vertical"
        >
          <BranchLogColumnTitles />

          {isListLoading
            ? emptyArray().map((_, index) => <BranchesLogListRowSkeleton key={'skeleton-' + String(index)} />)
            : pagination.data.map((branchesLog) => <BranchesLogListRow key={branchesLog.id} branchesLog={branchesLog} />)}
        </ScrollableBlock>
      )}

      <Pagination
        pagination={pagination}
        showPaginationInfo={true}
        showMorePageButtons={true}
        type={PaginationType.ARROW}
        onChange={branchesLogStore.fetchBranchesLogList}
      />
    </div>
  );
};

export default observer(BranchesLogList);
